/** Тип контакта пользователя. */
export enum UserContactTypeEnum {
  EMAIL = 'email',
  PHONE = 'phone',
}

/** Состояние привязки контакта к пользователю. */
export enum UserContactStatusEnum {
  PENDING = 'pending',
  VERIFIED = 'verified',
  REVOKED = 'revoked',
}

/** Контакт пользователя, доступный для просмотра в административной панели. */
export interface IUserContact {
  id: string;
  type: UserContactTypeEnum;
  address: string;
  status: UserContactStatusEnum;
  verifiedAt: string | null;
  revokedAt: string | null;
  createdAt: string;
  updatedAt: string;
}
